import "./HeaderPublic.css";
import logo from "../../../assets/Unstract.svg";
import { Image } from "antd";

function HeaderPublic() {
  return (
    <div className="custom-tools-header-layout-public">
      <Image src={logo} height={20} alt="Logo" />
    </div>
  );
}
export { HeaderPublic };
